/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GiftCardIssuanceStatus = {
    PENDING_ISSUANCE: 'PENDING_ISSUANCE',
    ISSUING: 'ISSUING',
    ISSUED: 'ISSUED',
    DELIVERED: 'DELIVERED',
    FAILED: 'FAILED'
} as const;
export type GiftCardIssuanceStatus = typeof GiftCardIssuanceStatus[keyof typeof GiftCardIssuanceStatus];


export function instanceOfGiftCardIssuanceStatus(value: any): boolean {
    for (const key in GiftCardIssuanceStatus) {
        if (Object.prototype.hasOwnProperty.call(GiftCardIssuanceStatus, key)) {
            if (GiftCardIssuanceStatus[key as keyof typeof GiftCardIssuanceStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GiftCardIssuanceStatusFromJSON(json: any): GiftCardIssuanceStatus {
    return GiftCardIssuanceStatusFromJSONTyped(json, false);
}

export function GiftCardIssuanceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): GiftCardIssuanceStatus {
    return json as GiftCardIssuanceStatus;
}

export function GiftCardIssuanceStatusToJSON(value?: GiftCardIssuanceStatus | null): any {
    return value as any;
}

export function GiftCardIssuanceStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): GiftCardIssuanceStatus {
    return value as GiftCardIssuanceStatus;
}

